import { input, output, TODO } from '@b2b/types/core';
import angular from 'angular';

/**
 * Represents a ticket type item that can be selected.
 * Based on the structure returned by getRemainingPricesForEvent.
 */
export interface TicketTypeItem {
  name: string;
  ticketingTypeName?: string;
  ticketingTypeDescription?: string;
  price: string | number | null;
  discountedPrice?: string | number | null;
  personType?: {
    id?: string;
    name?: string;
    description?: string;
  };
  csrDisabled?: boolean;
  salesChannels?: TODO[];
}

export interface TicketTypeSelectorSelectEvent {
  selectedItem: TicketTypeItem;
}

class TicketTypeSelectorController {
  static $inject = ['$element'];

  items = input<TicketTypeItem[]>([]);
  eventId = input<string>('');
  label = input<string>('');
  disabled = input<boolean>(false);
  onSelect = output<TicketTypeSelectorSelectEvent>();

  selectedItem: TicketTypeItem | null = null;

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-ticket-type-selector');
  }

  get computedLabel(): string {
    if (this.label) {
      return this.label;
    }

    const count = this.items?.length ?? 0;
    return count > 0 ? `Add Ticket Type (${count} more)` : 'Add Ticket Type';
  }

  get uniqueName(): string {
    return `ticket-type-selector-${this.eventId}`;
  }

  handleChange(): void {
    if (this.selectedItem && typeof this.selectedItem === 'object') {
      this.onSelect({ $event: { selectedItem: this.selectedItem } });
      this.selectedItem = null; // Reset after selection
    }
  }
}

export const TicketTypeSelectorComponentModule = angular
  .module('acme.common.component.ticketTypeSelector', ['acme.common.directive.combobox'])
  .component('acmeTicketTypeSelector', {
    templateUrl: 'common/components/ticket-type-selector/ticket-type-selector.component.tpl.html',
    controller: TicketTypeSelectorController,
    bindings: {
      items: '<',
      eventId: '<',
      label: '<',
      disabled: '<',
      onSelect: '&',
    },
  }).name;
